import { Context, Effect } from 'effect'
import { AnalyticsClient } from '~/features/analytics/core'
import type { User } from '@features/auth/auth-client-adapter'
import type { Organization, STSDK } from '@st/sdk'
import type { AnalyticsEvent } from '~/features/analytics/analytics-events'
import type { EventData, TrackOptions } from '~/features/analytics/core'

export type AnalyticsService = {
  setOrganization: (organization: Organization) => Effect.Effect<void>
  setGroup: (
    groupName: string,
    groupId: string,
    groupProperties?: Record<string, string>
  ) => Effect.Effect<void>
  track: (event: AnalyticsEvent, data?: EventData, options?: TrackOptions) => Effect.Effect<void>
  trackLocationChanged: (location: string) => Effect.Effect<void>
  trackUserIdentified: (user: User) => Effect.Effect<void>
  trackUserAnonymous: () => Effect.Effect<void>
}

export class Analytics extends Context.Service<Analytics, AnalyticsService>()('Analytics') {}

export function makeAnalyticsService(analytics: AnalyticsClient, sdk: STSDK): AnalyticsService {
  return {
    setOrganization: analytics.setOrganization,
    setGroup: analytics.setGroup,
    track: analytics.track,
    trackLocationChanged: analytics.trackLocationChanged,
    trackUserIdentified: (user) => analytics.trackUserIdentified(user, { sdk }),
    trackUserAnonymous: analytics.trackUserAnonymous
  }
}
